"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.$facet = void 0;
var aggregator_1 = require("../../aggregator");
var util_1 = require("../../util");
/**
 * Processes multiple aggregation pipelines within a single stage on the same set of input documents.
 * Enables the creation of multi-faceted aggregations capable of characterizing data across multiple dimensions, or facets, in a single stage.
 */
function $facet(collection, expr, options) {
    return collection.transform(function (array) {
        return [
            (0, util_1.objectMap)(expr, function (pipeline) {
                return new aggregator_1.Aggregator(pipeline, options).run(array);
            }),
        ];
    });
}
exports.$facet = $facet;
